import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { WarehouseLabelDisplay } from "../models/WarehouseLabelDisplay";
import { DefaultResponseWithData } from "../models/system";

export const warehouseLabelDisplayQueryKey = ["label", "warehouseDisplay"] as const;

export const warehouseLabelDisplayStaleTimeMs = 1000 * 60 * 60; // 1 hour

export default function useWarehouseLabels() {
  const { get } = useApiHelper();

  const warehouseLabelDisplay = useQuery(
    warehouseLabelDisplayQueryKey,
    () =>
      get<DefaultResponseWithData<WarehouseLabelDisplay>>(`/template/warehouse/label/display`),
    { staleTime: warehouseLabelDisplayStaleTimeMs }
  );

  return { warehouseLabelDisplay };
}
